import createStoreRouterObject from './createStoreRouterObject';
import getRenderArgs from './getRenderArgs'; // This function returns a promise. It doesn't need to be an async function
// because it doesn't use the promise's value.

export default function getStoreRenderArgs(_ref) {
  var store = _ref.store,
      _ref$getFound = _ref.getFound,
      getFound = _ref$getFound === void 0 ? function (_ref2) {
    var found = _ref2.found;
    return found;
  } : _ref$getFound,
      matchContext = _ref.matchContext,
      resolver = _ref.resolver;
  var router = createStoreRouterObject(store);
  var match = getFound(store.getState()).resolvedMatch;
  return getRenderArgs(router, {
    match: match,
    matchContext: matchContext,
    resolver: resolver
  });
}